import type { FunctionComponent } from 'react';

interface Props {
  width: number;
  height: number;
}

const ProLogoIcon: FunctionComponent<Props> = ({
  width = undefined,
  height = undefined,
}) => (
  <svg width={width} height={height} viewBox="0 0 43 16">
    <defs>
      <linearGradient
        id="a"
        x1="17.3371816%"
        x2="72.3274309%"
        y1="75.4517429%"
        y2="32.5645336%"
      >
        <stop offset=".044188%" stopColor="#E6685A" />
        <stop offset="100%" stopColor="#FFB950" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="nonzero">
      <path
        fill="url(#a)"
        d="M16.7483294 5.97221669L12.2983196.54046448c-.323827-.3931554-.8252365-.5793869-1.3266461-.50696355L3.99372401 1.14054378c-.50140955.08276955-.91925084.41384778-1.10727942.88977274L.35850479 8.56911157c-.17758255.47592491-.0940143 1.00358086.21936667 1.39673627L5.0278812 15.3976001c.32382701.3931553.82523656.5793868 1.32664611.5069635l6.97794959-1.1070429c.5014095-.0827695.9192508-.4138477 1.1072794-.8897727l2.5279398-6.53879504c.1880285-.47592496.1044603-1.00358085-.2193667-1.39673627z"
      />
      <path
        fill="#FFF"
        d="M10.5648115 4.80812081L8.99995088 7.6077792 7.45581696 4.29157867l-1.92757664.50621129-2.38356245 6.19850564h2.12447959l1.44050078-3.65711832 1.40941088 3.48149402h1.08814805l2.09338963-3.72943423v4.77284933L13.28 11.1925816V5.29367041z"
      />
      <g fill="#0C193A">
        <path d="M27.20317933 6.39193728c0 1.09777067-.31792296 1.94572979-.95377859 2.54390279-.63585632.59817301-1.53902191.89725502-2.70952451.89725502h-.73266048v3.25969048H20.2V3.266667h3.33987623c1.2189071 0 2.13417365.27107808 2.74582737.81324237.61165372.54216429.91747573 1.31283256.91747573 2.31202791zm-4.48298757 1.36414059h.48464744c.3993869 0 .71687247-.11423323.95246638-.34270312.23559323-.22846989.35338846-.54375361.35338846-.94586061 0-.67627087-.36796894-1.01440124-1.10391859-1.01440124h-.68658369v2.30296497zM35.3736324 6.56657998c.7733574-.74611213 1.7103096-1.10424596 2.8406019-1.10424596 1.1302915 0 2.082116.35813383 2.8406018 1.10424596C41.8281936 7.29776988 42.2 8.23787118 42.2 9.38688388c0 1.14901267-.3866787 2.08911397-1.1451639 2.80538164-.7584858.71626768-1.695438 1.07440148-2.8406018 1.07440148-1.1302923 0-2.0821168-.3581338-2.8406019-1.07440148-.7584851-.73118991-1.1302916-1.67129121-1.1302916-2.80538164 0-1.1490127.3718065-2.089114 1.1302916-2.8203039zm2.8406019 4.52143959c.8328467 0 1.5169702-.67150095 1.5169702-1.70113569 0-1.044557-.6692512-1.73098017-1.5169702-1.73098017-.8328467 0-1.516971.70134541-1.516971 1.73098017.0148723 1.02963474.6841243 1.70113569 1.516971 1.70113569zm-5.6970396-5.72799986c.2228989 0 .434869.01780111.6359152.05340385l.1442285.02670193-.2294544 2.46325273c-.2097872-.05340412-.5004264-.08010578-.871925-.08010578-.5594339 0-.9658914.13017059-1.2193854.39051568-.2534934.26034508-.3802383.63528089-.3802383 1.12481866v3.71824327h-2.56333018V5.49352934h1.90774711l.39990607 1.20826218h.1245608c.2141578-.4005309.5124456-.72428852.8948709-.97128258.3824253-.24699405.7681232-.37048923 1.1571047-.37048923z" />
      </g>
    </g>
  </svg>
);

export default ProLogoIcon;
